import * as React from 'react';
import { CircleButton, CircleButtonProps } from '@minecraft.atoms';
import { BaseDropdownButton } from './BaseDropdownButton';
import { DropdownItemProps, OptionalProps } from './types';

export interface CircleDropdownButtonProps extends OptionalProps {
  block?: boolean;
  menuAlign?: 'right' | 'left';
  menuChildren?: React.ReactNode;
  menuItemsProps: DropdownItemProps[];
  mobileBlock?: boolean;
  toggleProps: Pick<CircleButtonProps, 'color' | 'size' | 'icon' | 'variant' | 'label'>;
}

export const CircleDropdownButton = ({
  'data-testid': dataTestId,
  block = false,
  className,
  menuAlign = 'right',
  menuChildren,
  menuItemsProps = [],
  mobileBlock = false,
  qaId,
  toggleProps,
}: CircleDropdownButtonProps) => (
  <BaseDropdownButton
    block={block}
    className={className}
    data-testid={dataTestId}
    menuAlign={menuAlign}
    menuChildren={menuChildren}
    menuItemsProps={menuItemsProps}
    mobileBlock={mobileBlock}
    qaId={qaId}
    toggleChildren={undefined}
    ToggleComponent={CircleButton}
    toggleProps={toggleProps}
  />
);
